import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CompetitionIntro() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4">赛事分类</span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
            丰富的赛事类型
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            无论你是竞技新手还是资深玩家，都能在这里找到适合你的赛事。
            六大分类涵盖从入门到高级的全方位竞技体验。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group block bg-background-100 rounded-xl overflow-hidden hover:bg-background-200/80 transition-all cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between">
                  <h3 className="font-heading text-lg font-bold text-background-50">{cat.name}</h3>
                  <span className="text-xs text-background-200 bg-background-950/40 px-2 py-1 rounded-full whitespace-nowrap">
                    {cat.articleCount} 篇
                  </span>
                </div>
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-8 h-8 flex items-center justify-center bg-primary-100 rounded-lg">
                    <i className={`${cat.icon} text-primary-600 text-sm`}></i>
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">{cat.description}</p>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/caodi-jingji"
            className="inline-flex items-center gap-2 px-6 py-3 border border-secondary-300 text-foreground-700 rounded-lg text-sm font-medium hover:bg-secondary-100 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部赛事分类
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}